export default __webpack_public_path__ + "c5ff534d6f781e0d09bd65bb331bf2a7.txt";